export interface SearchResultItem {
  id: string;
  type: string;
  title: string;
  subtitle: string;
  category: string;
  path: string;
}

export const freelances = [
  { id: 'fr-001', name: 'Koffi A.', title: 'Développeur Web Full-Stack', skills: 'React, Node.js, Python', rate: '50 000 FCFA / jour', path: '/work' },
  { id: 'fr-002', name: 'Adjoa M.', title: 'Designer UI/UX', skills: 'Figma, Prototypage', rate: '40 000 FCFA / projet', path: '/work' },
  { id: 'fr-003', name: 'Yao K.', title: 'Rédacteur SEO', skills: 'Contenu, Copywriting', rate: '25 000 FCFA / article', path: '/work' },
  { id: 'fr-004', name: 'Ama D.', title: 'Développeuse Mobile', skills: 'Flutter, React Native', rate: '60 000 FCFA / jour', path: '/work' },
];

export const formations = [
  { id: 'fo-001', name: 'Développement Web Complet', provider: 'WorldApeiron Learn', level: 'Débutant', price: 'Gratuit', path: '/learn' },
  { id: 'fo-002', name: 'Marketing Digital & SEO', provider: 'WorldApeiron Learn', level: 'Intermédiaire', price: '25 000 FCFA', path: '/learn' },
  { id: 'fo-003', name: 'Data Science Fondamentaux', provider: 'WorldApeiron Learn', level: 'Avancé', price: '50 000 FCFA', path: '/learn' },
];

export const emplois = [
  { id: 'em-001', name: 'Développeur Backend Senior', company: 'TechAfrika', city: 'Lomé', type: 'CDI', path: '/jobs' },
  { id: 'em-002', name: 'Chargé de Marketing', company: 'Groupe Mensah', city: 'Lomé', type: 'CDD', path: '/jobs' },
  { id: 'em-003', name: 'Comptable Confirmé', company: 'Banque Atlantique', city: 'Lomé', type: 'CDI', path: '/jobs' },
];

export const boutiques = [
  { id: 'bo-001', name: 'Mode Togolaise', seller: 'Mawu Couture', products: 42, rating: 4.8, path: '/shop' },
  { id: 'bo-002', name: 'Électroménager Lomé', seller: 'TechStore Togo', products: 120, rating: 4.6, path: '/shop' },
  { id: 'bo-003', name: 'Artisanat & Décoration', seller: 'Art du Togo', products: 65, rating: 4.9, path: '/shop' },
];

export const utilisateurs = [
  { id: 'us-001', name: 'Koffi Mensah', role: 'Entrepreneur', location: 'Lomé', path: '/directory' },
  { id: 'us-002', name: 'Adjoa Lawson', role: 'Freelance Designer', location: 'Lomé', path: '/work' },
  { id: 'us-003', name: 'Yao Agbeti', role: 'Étudiant', location: 'Kara', path: '/directory' },
];